import { c as _c } from "react/compiler-runtime";
import { IcoBuilding16 } from '@onefootprint/icons';
import type { HostedBusiness } from '@onefootprint/request-types';
import { Badge, Button, Divider, PageShell } from '@onefootprint/ui';
import { differenceInDays, differenceInHours, format, formatDistance } from 'date-fns';
import { useTranslation } from 'react-i18next';
export type CreateBusinessOnboardingProps = {
  businesses: HostedBusiness[];
  onSelect: (id: string) => void;
  onAddNew: () => void;
  isBusy: boolean;
};
export const CreateBusinessOnboarding = t0 => {
  const $0 = _c(45);
  const {
    businesses,
    onSelect,
    onAddNew,
    isBusy
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "createBusinessOnboarding.businessSelector"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($0[1] !== businesses.length) {
    t2 = $ => businesses.length === 1 ? $.title_one : $.title_other;
    $0[1] = businesses.length;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== businesses.length || $0[4] !== t || $0[5] !== t2) {
    t3 = t(t2, {
      count: businesses.length
    });
    $0[3] = businesses.length;
    $0[4] = t;
    $0[5] = t2;
    $0[6] = t3;
  } else {
    t3 = $0[6];
  }
  const title = t3;
  let t4;
  if ($0[7] !== t) {
    t4 = date => {
      const now = new Date();
      const activityDate = new Date(date);
      const hoursAgo = differenceInHours(now, activityDate);
      const daysAgo = differenceInDays(now, activityDate);
      if (hoursAgo < 24) {
        return t(_temp, {
          time: formatDistance(activityDate, now)
        });
      }
      if (daysAgo < 30) {
        return t($_1 => daysAgo === 1 ? $_1.lastActivity.days_one : $_1.lastActivity.days_other, {
          days: daysAgo,
          count: daysAgo
        });
      }
      return t(_temp2, {
        date: format(activityDate, "MM/dd/yyyy")
      });
    };
    $0[7] = t;
    $0[8] = t4;
  } else {
    t4 = $0[8];
  }
  const formatRelative = t4;
  let t5;
  if ($0[9] !== t) {
    t5 = t(_temp3);
    $0[9] = t;
    $0[10] = t5;
  } else {
    t5 = $0[10];
  }
  let t6;
  if ($0[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      headerTitleCentered: true
    };
    $0[11] = t6;
  } else {
    t6 = $0[11];
  }
  let t7;
  if ($0[12] !== businesses || $0[13] !== formatRelative || $0[14] !== onSelect || $0[15] !== t) {
    let t8;
    if ($0[17] !== formatRelative || $0[18] !== onSelect || $0[19] !== t) {
      t8 = business => <button key={business.id} type="button" onClick={() => onSelect(business.id)} className="bg-primary border border-tertiary p-5 pb-3 w-full block rounded-md cursor-pointer hover:border-primary text-left"><div className="flex items-center justify-between mb-3 h-5"><span className="text-caption-1 text-tertiary">{formatRelative(business.lastActivityAt)}</span>{business.isIncomplete ? <Badge variant="warning">{t(_temp4)}</Badge> : null}</div><div className="flex gap-3 items-center mb-5"><IcoBuilding16 color="primary" /><span className="text-label-2 text-primary">{business.name}</span></div><Divider /><div className="mt-3"><span className="text-caption-1 text-tertiary">{t(_temp5, {
              date: format(new Date(business.createdAt), "MM/dd/yyyy")
            })}</span></div></button>;
      $0[17] = formatRelative;
      $0[18] = onSelect;
      $0[19] = t;
      $0[20] = t8;
    } else {
      t8 = $0[20];
    }
    t7 = businesses.map(t8);
    $0[12] = businesses;
    $0[13] = formatRelative;
    $0[14] = onSelect;
    $0[15] = t;
    $0[16] = t7;
  } else {
    t7 = $0[16];
  }
  let t8;
  if ($0[21] !== t7) {
    t8 = <div className="flex flex-col gap-4 w-full">{t7}</div>;
    $0[21] = t7;
    $0[22] = t8;
  } else {
    t8 = $0[22];
  }
  let t9;
  if ($0[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider />;
    $0[23] = t9;
  } else {
    t9 = $0[23];
  }
  let t10;
  if ($0[24] !== t) {
    t10 = t(_temp6);
    $0[24] = t;
    $0[25] = t10;
  } else {
    t10 = $0[25];
  }
  let t11;
  if ($0[26] !== t10) {
    t11 = <span className="text-body-2 text-tertiary">{t10}</span>;
    $0[26] = t10;
    $0[27] = t11;
  } else {
    t11 = $0[27];
  }
  let t12;
  if ($0[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider />;
    $0[28] = t12;
  } else {
    t12 = $0[28];
  }
  let t13;
  if ($0[29] !== t11) {
    t13 = <div className="flex gap-4 w-full items-center">{t9}{t11}{t12}</div>;
    $0[29] = t11;
    $0[30] = t13;
  } else {
    t13 = $0[30];
  }
  let t14;
  if ($0[31] !== t) {
    t14 = t(_temp7);
    $0[31] = t;
    $0[32] = t14;
  } else {
    t14 = $0[32];
  }
  let t15;
  if ($0[33] !== isBusy || $0[34] !== onAddNew || $0[35] !== t14) {
    t15 = <Button onClick={onAddNew} fullWidth={true} size="large" loading={isBusy}>{t14}</Button>;
    $0[33] = isBusy;
    $0[34] = onAddNew;
    $0[35] = t14;
    $0[36] = t15;
  } else {
    t15 = $0[36];
  }
  let t16;
  if ($0[37] !== t13 || $0[38] !== t15 || $0[39] !== t8) {
    t16 = <div className="flex flex-col gap-5 w-full">{t8}{t13}{t15}</div>;
    $0[37] = t13;
    $0[38] = t15;
    $0[39] = t8;
    $0[40] = t16;
  } else {
    t16 = $0[40];
  }
  let t17;
  if ($0[41] !== t16 || $0[42] !== t5 || $0[43] !== title) {
    t17 = <PageShell title={title} subtitle={t5} options={t6}>{t16}</PageShell>;
    $0[41] = t16;
    $0[42] = t5;
    $0[43] = title;
    $0[44] = t17;
  } else {
    t17 = $0[44];
  }
  return t17;
};
function _temp($_0) {
  return $_0.lastActivity.hours;
}
function _temp2($_2) {
  return $_2.lastActivity.date;
}
function _temp3($_3) {
  return $_3.subtitle;
}
function _temp4($_4) {
  return $_4.status.incomplete;
}
function _temp5($_5) {
  return $_5.createdAt;
}
function _temp6($_6) {
  return $_6.or;
}
function _temp7($_7) {
  return $_7.cta;
}